/* unplugin-vue-components disabled */import script from "./AiQuestionStem.vue?vue&type=script&setup=true&lang=js"
export * from "./AiQuestionStem.vue?vue&type=script&setup=true&lang=js"

import "./AiQuestionStem.vue?vue&type=style&index=0&id=3908bfbe&lang=scss"

const __exports__ = script;

export default __exports__